import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AdminPanel.css";
const AdminPanel = () => {
  const [questions, setQuestions] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [formData, setFormData] = useState({});
  const [filterType, setFilterType] = useState("");
  const [editingQuestionId, setEditingQuestionId] = useState(null);

  useEffect(() => {
    fetchQuestions();
    fetchQuestionTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterType]);

  const fetchQuestions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/admin-get-questions`,
        {
          params: { question_type_id: filterType || undefined },
        }
      );
      console.log("API Response Status:", response.status);
      console.log("API Response Data:", response.data);
      setQuestions(response.data);
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  const fetchQuestionTypes = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/admin-get-question-types`
      );
      setQuestionTypes(response.data);
    } catch (error) {
      console.error("Error fetching question types:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData.question_id) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/${formData.question_id}`,
          formData
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/admin-add-question`,
          formData
        );
      }
      fetchQuestions();
      setFormData({});
    } catch (error) {
      console.error("Error saving question:", error);
    }
  };

  /* const handleDelete = async (question_id) => {
    if (window.confirm("Are you sure you want to delete this question?")) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/admin-delete-question/${question_id}`
        );
        fetchQuestions();
      } catch (error) {
        console.error("Error deleting question:", error);
      }
    }
  }; */

  const handleEdit = (question) => {
    setFormData(question);
    setEditingQuestionId(question.question_id);
  };

  return (
    <div className="container">
      <h2 className="my-4">DVSA Admin Panel</h2>

      <div className="mb-3">
        <label>Question Type</label>
        <select
          className="form-select"
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
        >
          <option value="">Select Type</option>
          {questionTypes.map((type) => (
            <option key={type.question_type_id} value={type.question_type_id}>
              {type.question_type_id}
            </option>
          ))}
        </select>
      </div>

      <form onSubmit={handleSubmit} className="mb-4">
        <div className="mb-3">
          <label>Question Text</label>
          <input
            name="question_text"
            value={formData.question_text || ""}
            onChange={handleInputChange}
            className="form-control"
            required
          />
        </div>

        <div className="mb-3">
          <label>Question Text (Bangla)</label>
          <input
            name="question_text_bangla"
            value={formData.question_text_bangla || ""}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label>Image URL</label>
          <input
            name="image"
            value={formData.image || ""}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>

        {["option_1", "option_2", "option_3", "option_4"].map(
          (option, index) => (
            <div key={option} className="mb-3">
              <label>{`Option ${index + 1}`}</label>
              <input
                name={option}
                value={formData[option] || ""}
                onChange={handleInputChange}
                className="form-control"
              />
              <label>{`Option ${index + 1} (Bangla)`}</label>
              <input
                name={`${option}_bangla`}
                value={formData[`${option}_bangla`] || ""}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
          )
        )}

        <div className="mb-3">
          <label>Correct Answer (1-4)</label>
          <input
            name="correct_answer"
            type="number"
            min="1"
            max="4"
            value={formData.correct_answer || ""}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label>Explanation</label>
          <textarea
            name="explanation"
            value={formData.explanation || ""}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label>Explanation (Bangla)</label>
          <textarea
            name="explanation_bangla"
            value={formData.explanation_bangla || ""}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label>Question Type</label>
          <select
            name="question_type_id"
            value={formData.question_type_id || ""}
            onChange={handleInputChange}
            className="form-select"
            required
          >
            <option value="">Select Type</option>
            {questionTypes.map((type) => (
              <option key={type.question_type_id} value={type.question_type_id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="btn btn-primary">
          {formData.question_id ? "Update" : "Add"} Question
        </button>
      </form>

      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Text (EN)</th>
              <th>Text (BN)</th>
              <th>Image</th>
              <th>Options (EN)</th>
              <th>Options (BN)</th>
              <th>Explanation (EN)</th>
              <th>Explanation (BN)</th>
              <th>Type ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {questions.length > 0 ? (
              questions.map((question) => (
                <React.Fragment key={question.question_id}>
                  <tr>
                    <td>{question.question_id}</td>
                    <td>{question.question_text}</td>
                    <td className="bangla-text">
                      {question.question_text_bangla}
                    </td>
                    <td>
                      {question.image ? (
                        <img
                          src={question.image}
                          alt="Question"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>
                    <td>
                      <ul className="list-unstyled">
                        <li>1. {question.option_1}</li>
                        <li>2. {question.option_2}</li>
                        <li>3. {question.option_3}</li>
                        <li>4. {question.option_4}</li>
                      </ul>
                    </td>
                    <td>
                      <ul className="list-unstyled">
                        <li className="bangla-text">
                          ১. {question.option_1_bangla}
                        </li>
                        <li className="bangla-text">
                          ২. {question.option_2_bangla}
                        </li>
                        <li className="bangla-text">
                          ৩. {question.option_3_bangla}
                        </li>
                        <li className="bangla-text">
                          ৪. {question.option_4_bangla}
                        </li>
                      </ul>
                    </td>
                    <td>{question.explanation}</td>
                    <td className="bangla-text">
                      {question.explanation_bangla}
                    </td>
                    <td>{question.question_type_id}</td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm me-2"
                        onClick={() => handleEdit(question)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>

                  {/* Inline edit form */}
                  {editingQuestionId === question.question_id && (
                    <tr>
                      <td colSpan="11">
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-6 mb-2">
                              <label>Question Text</label>
                              <input
                                name="question_text"
                                value={formData.question_text || ""}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                              />
                            </div>
                            <div className="col-md-6 mb-2">
                              <label>Question Text (Bangla)</label>
                              <input
                                name="question_text_bangla"
                                value={formData.question_text_bangla || ""}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="mb-2">
                            <label>Image URL</label>
                            <input
                              name="image"
                              value={formData.image || ""}
                              onChange={handleInputChange}
                              className="form-control"
                            />
                          </div>

                          {["option_1", "option_2", "option_3", "option_4"].map(
                            (option, index) => (
                              <div key={option} className="row mb-2">
                                <div className="col-md-6">
                                  <label>{`Option ${index + 1}`}</label>
                                  <input
                                    name={option}
                                    value={formData[option] || ""}
                                    onChange={handleInputChange}
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>{`Option ${
                                    index + 1
                                  } (Bangla)`}</label>
                                  <input
                                    name={`${option}_bangla`}
                                    value={formData[`${option}_bangla`] || ""}
                                    onChange={handleInputChange}
                                    className="form-control"
                                  />
                                </div>
                              </div>
                            )
                          )}

                          <div className="mb-2">
                            <label>Correct Answer (1-4)</label>
                            <input
                              name="correct_answer"
                              type="number"
                              min="1"
                              max="4"
                              value={formData.correct_answer || ""}
                              onChange={handleInputChange}
                              className="form-control"
                            />
                          </div>

                          <div className="mb-2">
                            <label>Explanation</label>
                            <textarea
                              name="explanation"
                              value={formData.explanation || ""}
                              onChange={handleInputChange}
                              className="form-control"
                            />
                          </div>

                          <div className="mb-2">
                            <label>Explanation (Bangla)</label>
                            <textarea
                              name="explanation_bangla"
                              value={formData.explanation_bangla || ""}
                              onChange={handleInputChange}
                              className="form-control"
                            />
                          </div>

                          <div className="mb-2">
                            <label>Question Type</label>
                            <select
                              name="question_type_id"
                              value={formData.question_type_id || ""}
                              onChange={handleInputChange}
                              className="form-select"
                              required
                            >
                              <option value="">Select Type</option>
                              {questionTypes.map((type) => (
                                <option
                                  key={type.question_type_id}
                                  value={type.question_type_id}
                                >
                                  {type.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <button
                            type="submit"
                            className="btn btn-success me-2"
                          >
                            Update
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              setEditingQuestionId(null);
                              setFormData({});
                            }}
                          >
                            Cancel
                          </button>
                        </form>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="text-center">
                  No questions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminPanel;
